import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "./style";

interface InfoCardProps extends WithStyles<typeof styles> {
	label: string;
	value: string | number | boolean;
	fieldName?: string;
}

const Component: React.FC<InfoCardProps> = ({ classes = {}, label, value, fieldName }) => {
	const theme = Mui.useTheme();
	
	const getValueDisplay = (val: string | number | boolean): string => {
		if (typeof val === 'boolean') {
			return val ? 'True' : 'False';
		}
		return String(val);
	};

	const getValueChipColor = (): 'default' => {
		return 'default';
	};

	return (
		<Mui.Box 
			border={1} 
			borderColor="grey.300" 
			borderRadius={1} 
			p={1} 
			mb={1}
			className={classes.container}
		>
			<Mui.Box display="flex" justifyContent="space-between" alignItems="center">
				<Mui.Typography variant="caption" className={classes.label}>
					{label}
				</Mui.Typography>
			</Mui.Box>
			{fieldName && (
				<Mui.Typography variant="caption" color="textSecondary" className={classes.fieldName}>
					{fieldName}
				</Mui.Typography>
			)}
			<Mui.Box mt={0.5}>
				<Mui.Chip
					label={getValueDisplay(value)}
					size="small"
					color={getValueChipColor()}
					className={classes.valueChip}
				/>
			</Mui.Box>
		</Mui.Box>
	);
};

export const InfoCard = withStyles(Component, styles);